import { render, staticRenderFns } from "./billConfirm.vue?vue&type=template&id=5064d86f&scoped=true&"
import script from "./billConfirm.vue?vue&type=script&lang=js&"
export * from "./billConfirm.vue?vue&type=script&lang=js&"
import style0 from "./billConfirm.vue?vue&type=style&index=0&id=5064d86f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064d86f",
  null
  
)

export default component.exports